import { compact, flow, map } from 'lodash/fp'
import { appendBefore, concatWith, createPageCreator } from 'e-submission/domain/data-model/form/utils'

import baseForm from 'e-submission/domain/data-model/form'
import { insuredHealth, payerHealth } from 'e-submission/domain/data-model/form/pages/health'
import { submit } from 'e-submission/domain/data-model/form/pages/submit'
import signature from './signature'

export default (app) => {
  const createPage = createPageCreator(app)

  return flow(
    baseForm,
    map(createPage),
    concatWith([createPage(signature(app)), createPage(submit())]),
    appendBefore(null, 'FATCA', [createPage(insuredHealth(app)), createPage(payerHealth(app))]),
    compact
  )(app)
}
